import { Animation } from '@ionic/core';
import { createAnimation, EASING_EMPHASIZED_ACCELERATE, fadeOut, DURATION_SHORT_4 } from '../../../utils/animations';

export function dialogCloseAnimation(dialogEl: HTMLElement, backdropEl: HTMLSyBackdropElement): Animation {
  const dialogOpenAnim = createAnimation();
  const backDropAnim = fadeOut().duration(DURATION_SHORT_4).easing(EASING_EMPHASIZED_ACCELERATE).addElement(backdropEl);
  const dialogDivFade = fadeOut().duration(DURATION_SHORT_4).easing(EASING_EMPHASIZED_ACCELERATE).addElement(dialogEl);

  dialogOpenAnim.addAnimation(backDropAnim);
  dialogOpenAnim.addAnimation(dialogDivFade);
  return dialogOpenAnim;
}
